import script from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=78656e95&scoped=true&lang=postcss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78656e95"]])

export default __exports__